interface FilterToggleButtonProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  icon?: string;
  vertical?: boolean;
}

export const FilterToggleButton = ({
  label,
  isSelected,
  onClick,
  icon,
  vertical = false
}: FilterToggleButtonProps) => {
  const baseClasses = `border-2 text-sm font-medium transition-all duration-200 ${
    vertical ? "rounded-3xl" : "rounded-full"
  } ${
    isSelected
      ? "border-[#0fff78] bg-gradient-to-br from-[#0fff78] to-[#86faff] text-black"
      : "border-gradient-to-br bg-transparent from-[#0fff78] to-[#86faff] text-gray-700 hover:bg-gradient-to-br hover:from-[#0fff78]/20 hover:to-[#86faff]/20 hover:text-black"
  }`;

  const layoutClasses = vertical
    ? "h-24 flex-1 flex flex-col items-center justify-center px-2 py-2 min-w-0"
    : "px-4 py-2";

  const textClasses = vertical ? "text-sm leading-none whitespace-nowrap" : "";

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${layoutClasses} ${textClasses}`}
      style={{
        ...(!isSelected
          ? {
              background:
                "linear-gradient(white, white) padding-box, linear-gradient(to bottom right, #0fff78, #86faff) border-box",
              border: "2px solid transparent"
            }
          : {}),
        ...(vertical ? { writingMode: "vertical-rl", textOrientation: "mixed" } : {})
      }}
    >
      {icon && !vertical && <span className="mr-1">{icon}</span>}
      {vertical && icon && <span className="mb-1 text-xs">{icon}</span>}
      {label}
    </button>
  );
};
